// Import necessary modules and functions
import { css } from '@emotion/react';
import { darken } from 'polished';
import Mixin from '../../../util/mixin';
import {Hover} from './_hover.mixin';

// Mixin emulation with JavaScript
export class TableRowVariant extends Mixin {
  include($) {
    const [state, background, border = null] = this.args;
    const hoverBackground = darken(0.05, background);

    return css`
      .table-${state} {
        &,
        > th,
        > td {
          background-color: ${background};
        }

        ${border &&
        css`
          th,
          td,
          thead th,
          tbody + tbody {
            border-color: ${border};
          }
        `}
      }

      .table-hover {
        .table-${state} {
          ${new Hover().include($, css`
            background-color: ${hoverBackground};

            > td,
            > th {
              background-color: ${hoverBackground};
            }
          `)};
        }
      }
    `;
  };
};